module.exports = __webpack_public_path__ + "static/media/kiit_logo.26972c01.png";